var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-wrapper ml-auto"},[_c('h2',{staticClass:"text-h5 mb-4"},[_vm._v(" "+_vm._s(_vm.$t("bookingSummary"))+" ")]),_c('booking-summary-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }